import { defineComponent, PropType, ref, watch } from "vue";
import {
    useFetch,
    Member,
} from "../../../utils.js";
import { TimeRangeParams } from "../timeRange.js";
import { VoiceEntry } from "../types.js";
import { VoiceSessionsCard } from "../voice/VoiceSessionsCard.js";
import { createSelfVoiceSessionItems } from "../voice/sessionModel.js";

export default defineComponent({
    name: "UserVoiceSelfMenu",
    props: {
        userId: {
            type: String,
            required: true,
        },
        user: {
            type: Object as PropType<Member>,
            required: true,
        },
        timeRange: {
            type: Object as PropType<TimeRangeParams>,
            required: true,
        },
        limit: {
            type: Number,
            default: 99,
        },
    },
    setup(props) {
        const { fetch } = useFetch();
        const entries   = ref<VoiceEntry[]>([]);
        const loading   = ref<boolean>(true);

        async function load() {
            loading.value = true;

            try {
                const url = `/api/voice-interactions?userId=${props.userId}&targetId=${props.userId}&before=${props.timeRange.before}&after=${props.timeRange.after}&limit=${props.limit}`;
                const res = await fetch(url).then((r) => r.json());

                entries.value = res.result || [];
            } finally {
                loading.value = false;
            }
        }

        watch(() => [ props.userId, props.timeRange.key, props.limit ], load, { immediate: true });

        return () => {
            if (loading.value)
                return <div class="notice">Chargement…</div>;

            return (
                <VoiceSessionsCard
                    title="Sessions de l'utilisateur"
                    emptyText="Aucune interaction sur la période sélectionnée."
                    currentUserId={props.userId}
                    timeRange={props.timeRange}
                    sessions={createSelfVoiceSessionItems(props.user, entries.value)}
                />
            );
        };
    },
});
